// src/components/ScheduleModal/index.js (forced update for translations)

import React, { useState, useEffect, useContext, useRef } from "react";

import * as Yup from "yup";
import { Formik, Form, Field, FieldArray } from "formik";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";

import { makeStyles, useTheme } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CircularProgress from "@material-ui/core/CircularProgress";

import { i18n } from "../../translate/i18n";
import ContactModal from "../ContactModal";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import {
  Chip,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  Typography,
} from "@material-ui/core";
import Autocomplete, {
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import moment from "moment";
import { AuthContext } from "../../context/Auth/AuthContext";
import { isArray, capitalize } from "lodash";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import AttachFile from "@material-ui/icons/AttachFile";
import { head } from "lodash";
import ConfirmationModal from "../ConfirmationModal";
import useQueues from "../../hooks/useQueues";
import UserStatusIcon from "../UserModal/statusIcon";
import { Facebook, Instagram, WhatsApp, FlashOn } from "@material-ui/icons";
import CloseIcon from "@material-ui/icons/Close";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import Collapse from "@material-ui/core/Collapse";
import Box from "@material-ui/core/Box";
import EventIcon from "@material-ui/icons/Event";
import SaveIcon from "@material-ui/icons/Save";
import { getStandardButtonStyles } from "../../styles/standardButtons";

const useStyles = makeStyles((theme) => ({
  ...getStandardButtonStyles(theme),
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  btnWrapper: {
    position: "relative",
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  reminderNote: {
    padding: "8px 12px",
    backgroundColor: theme.palette.type === "light" ? "#f5f5f5" : "rgba(255, 255, 255, 0.05)",
    borderRadius: "8px",
    marginTop: "0px",
    color: theme.palette.type === "light" ? "rgba(0, 0, 0, 0.65)" : "#ddd",
    fontSize: "0.82rem",
    border: `1px solid ${theme.palette.divider}`,
    display: "flex",
    alignItems: "center",
    minHeight: "40px"
  },
  dialogPaper: {
    maxWidth: "820px",
    width: "100%",
    borderRadius: 16,
    backgroundColor: theme.palette.type === "dark" ? "#1E2126" : "#FFFFFF",
    border: theme.palette.type === "dark" ? `1px solid ${theme.palette.primary.main}40` : "1px solid rgba(0, 0, 0, 0.12)",
    boxShadow: "0 16px 48px rgba(0, 0, 0, 0.55)",
    overflow: "hidden",
    "& *:before, & *:after": {
      borderBottom: "none !important",
    },
    "& .MuiInput-underline:before, & .MuiInput-underline:after": {
      display: "none !important",
      borderBottom: "none !important",
      content: "none !important",
    },
    "& .MuiInputBase-root:before, & .MuiInputBase-root:after": {
      display: "none !important",
      borderBottom: "none !important",
      content: "none !important",
    },
    "& .MuiAutocomplete-inputRoot:before, & .MuiAutocomplete-inputRoot:after": {
      display: "none !important",
      borderBottom: "none !important",
      content: "none !important",
    },
  },
  helpBox: {
    backgroundColor:
      theme.palette.type === "dark" ? "rgba(0, 180, 216, 0.08)" : "rgba(0, 180, 216, 0.05)",
    borderBottom: `1px solid ${
      theme.palette.type === "dark" ? "rgba(0, 180, 216, 0.2)" : "rgba(0, 180, 216, 0.15)"
    }`,
    padding: theme.spacing(1.5, 3),
  },
  dialogTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px 24px 12px 24px",
    borderBottom: theme.palette.type === "dark" ? "1px solid rgba(255, 255, 255, 0.08)" : "1px solid rgba(0, 0, 0, 0.08)",
  },
  dialogTitleText: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    fontSize: "1.1rem",
    fontWeight: 700,
    color: theme.palette.type === "dark" ? "#FFF" : theme.palette.primary.main,
  },
  dialogContent: {
    padding: "20px 24px",
    backgroundColor: theme.palette.type === "dark" ? "#16191E" : "#fdfdfd",
  },
  dialogActions: {
    padding: "14px 24px",
    borderTop: theme.palette.type === "dark" ? "1px solid rgba(255, 255, 255, 0.08)" : "1px solid rgba(0, 0, 0, 0.08)",
    backgroundColor: theme.palette.type === "dark" ? "#1E2126" : "#f8fafc",
    display: "flex",
    justifyContent: "flex-end",
    gap: 12,
  },
  formControl: {
    minWidth: "100%",
  },
  autocompleteInput: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
      "& fieldset": {
        borderColor: theme.palette.type === "dark" ? "rgba(255, 255, 255, 0.15)" : "rgba(0, 0, 0, 0.23)",
      },
      "&:hover fieldset": {
        borderColor: theme.palette.type === "dark" ? "rgba(255, 255, 255, 0.3)" : "rgba(0, 0, 0, 0.4)",
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
      },
    },
    "& .MuiInput-underline:before, & .MuiInput-underline:after": {
      display: "none !important",
      borderBottom: "none !important",
      content: "none !important",
    },
    "&:before, &:after": {
      display: "none !important",
      borderBottom: "none !important",
      content: "none !important",
    },
  },
}));

const getScheduleSchema = () => Yup.object().shape({
  body: Yup.string()
    .min(5, i18n.t("scheduleModal.validation.bodyTooShort"))
    .required(i18n.t("scheduleModal.validation.required")),
  contactId: Yup.number().required(i18n.t("scheduleModal.validation.required")),
  sendAt: Yup.string()
    .required(i18n.t("scheduleModal.validation.required"))
    .test("is-future", i18n.t("scheduleModal.validation.futureDate"), (value) => {
      return value ? moment(value).isAfter(moment().add(10, "seconds")) : false;
    }),
  reminderDate: Yup.string().nullable()
});

const ScheduleModal = ({
  open,
  onClose,
  scheduleId,
  contactId,
  cleanContact,
  reload,
  message,
  fromMessageInput = false,
  user,
  ticket,
  whatsappId
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const history = useHistory();
  const isMounted = useRef(true);
  const { companyId } = user;
  const isAdmin = user.profile === 'admin';

  const initialState = {
    body: message || "", // ✅ Pre-popular com mensagem se fornecida
    contactId: contactId || "", // ✅ Pre-popular com contactId se fornecido
    sendAt: "",
    sentAt: "",
    openTicket: "enabled",
    ticketUserId: user.id,
    queueId: "",
    statusTicket: "open", // ✅ Status baseado na origem
    intervalo: 1,
    valorIntervalo: 0,
    enviarQuantasVezes: 1,
    tipoDias: 4,
    assinar: false,
    // ✅ Novos campos para lembrete
    reminderDate: "",
  };

  const initialContact = {
    id: "",
    name: "",
    number: "",
    channel: "",
  };

  const [schedule, setSchedule] = useState(initialState);
  const [showHelp, setShowHelp] = useState(false);
  const [currentContact, setCurrentContact] = useState(initialContact);
  const [contacts, setContacts] = useState([initialContact]);
  const [loadingContacts, setLoadingContacts] = useState(false);
  const [contactSearchParam, setContactSearchParam] = useState("");
  const [intervalo, setIntervalo] = useState(1);
  const [tipoDias, setTipoDias] = useState(4);
  const [attachment, setAttachment] = useState(null);
  const attachmentFile = useRef(null);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const messageInputRef = useRef();
  const sendAtRef = useRef(null);
  const reminderDateRef = useRef(null);
  const [channelFilter, setChannelFilter] = useState("whatsapp");
  const [contactModalOpen, setContactModalOpen] = useState(false);
  const [contactInitialValues, setContactInitialValues] = useState({ name: "", number: "" });
  const [whatsapps, setWhatsapps] = useState([]);
  const [selectedWhatsapps, setSelectedWhatsapps] = useState([]);
  const [loading, setLoading] = useState(false);
  const [queues, setQueues] = useState([]);
  const [allQueues, setAllQueues] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedQueue, setSelectedQueue] = useState(null);
  const { findAll: findAllQueues } = useQueues();
  const [options, setOptions] = useState([]);
  const [searchParam, setSearchParam] = useState("");

  // Estados para quickMessages
  const [quickMessages, setQuickMessages] = useState([]);
  const [filteredQuickMessages, setFilteredQuickMessages] = useState([]);
  const [loadingQuickMessages, setLoadingQuickMessages] = useState(false);
  const [selectedQuickMessage, setSelectedQuickMessage] = useState("");
  const [quickMessageSearch, setQuickMessageSearch] = useState("");
  const [showAllQuickMessages, setShowAllQuickMessages] = useState(false);
  const [quickMessageMedia, setQuickMessageMedia] = useState(null);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (isMounted.current) {
      const loadQueues = async () => {
        const list = await findAllQueues();
        setAllQueues(list);
        setQueues(list);
      };
      loadQueues();
    }
  }, []);

  // Buscar quickMessages quando o modal abrir
  useEffect(() => {
    if (open && user?.companyId) {
      fetchQuickMessages();
    }
  }, [open, user?.companyId, user?.id]);

  // Filtrar respostas rápidas baseado na busca
  useEffect(() => {
    if (quickMessageSearch.trim() === "" && !showAllQuickMessages) {
      setFilteredQuickMessages([]);
    } else if (quickMessageSearch.trim() === "" && showAllQuickMessages) {
      setFilteredQuickMessages(quickMessages);
    } else {
      const filtered = quickMessages.filter(qm =>
        qm.message.toLowerCase().includes(quickMessageSearch.toLowerCase()) ||
        qm.shortcode.toLowerCase().includes(quickMessageSearch.toLowerCase())
      );
      setFilteredQuickMessages(filtered);
    }
  }, [quickMessageSearch, quickMessages, showAllQuickMessages]);

  const fetchQuickMessages = async () => {
    setLoadingQuickMessages(true);
    try {
      console.log("🔍 Buscando quickMessages com params:", {
        companyId: user?.companyId,
        userId: user?.id,
        isOficial: "false"
      });

      const { data } = await api.get("/quick-messages/list", {
        params: {
          companyId: user?.companyId,
          userId: user?.id,
          isOficial: "false"
        }
      });

      console.log("📋 Resposta da API quickMessages:", data);
      setQuickMessages(data || []);
      setFilteredQuickMessages(data || []);
    } catch (err) {
      console.error("❌ Erro ao buscar respostas rápidas:", err);
      toastError(err);
      setQuickMessages([]);
      setFilteredQuickMessages([]);
    } finally {
      setLoadingQuickMessages(false);
    }
  };

  // Função para baixar mídia da quickMessage
  const downloadQuickMessageMedia = async (mediaPath, mediaName, mediaType) => {
    try {
      // console.log("📎 Baixando mídia da quickMessage:", { mediaPath, mediaName, mediaType });

      // Construir URL correta usando a URL base do backend
      const downloadUrl = mediaPath;

      // console.log("🔗 URL de download:", downloadUrl);

      const response = await fetch(downloadUrl, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (!response.ok) {
        throw new Error(`Erro ao baixar mídia: ${response.status}`);
      }

      const blob = await response.blob();
      const file = new File([blob], mediaName, {
        type: blob.type || getMediaTypeFromExtension(mediaName, mediaType)
      });

      // console.log("✅ Mídia baixada com sucesso:", file);
      return file;
    } catch (err) {
      console.error("❌ Erro ao baixar mídia da quickMessage:", err);
      toastError(err);
      return null;
    }
  };

  // Função auxiliar para determinar o tipo MIME baseado na extensão
  const getMediaTypeFromExtension = (fileName, mediaType) => {
    const extension = fileName.split('.').pop().toLowerCase();

    switch (mediaType) {
      case 'image':
        return `image/${extension === 'jpg' ? 'jpeg' : extension}`;
      case 'audio':
        return `audio/${extension}`;
      case 'video':
        return `video/${extension}`;
      default:
        return 'application/octet-stream';
    }
  };

  useEffect(() => {
    if (!open) return;
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchUsers = async () => {
        try {
          const { data } = await api.get("/users/", {
            params: searchParam ? { searchParam } : undefined,
          });
          setOptions(data.users || []);
          setLoading(false);
        } catch (err) {
          setLoading(false);
          toastError(err);
        }
      };

      fetchUsers();
    }, searchParam ? 300 : 0);
    return () => clearTimeout(delayDebounceFn);
  }, [searchParam, open]);

  useEffect(() => {
    api
      .get(`/whatsapp/filter`, {
        params: { session: 0, channel: channelFilter },
      })
      .then(({ data }) => {
        let mappedWhatsapps = data.map((whatsapp) => ({
          ...whatsapp,
          selected: false,
        }));

        const targetWpId = ticket?.whatsappId || whatsappId || ticket?.whatsapp?.id;
        const targetBrandId = ticket?.whatsapp?.brandId;

        if (targetWpId) {
          const matchingWp = mappedWhatsapps.find(w => Number(w.id) === Number(targetWpId));
          const brandToFilter = targetBrandId || matchingWp?.brandId;
          if (brandToFilter) {
            mappedWhatsapps = mappedWhatsapps.filter(w => Number(w.brandId) === Number(brandToFilter));
          } else if (matchingWp) {
            mappedWhatsapps = [matchingWp];
          }
        }

        setWhatsapps(mappedWhatsapps);
        if (targetWpId && mappedWhatsapps.some(w => Number(w.id) === Number(targetWpId))) {
          setSelectedWhatsapps(Number(targetWpId));
        } else if (mappedWhatsapps.length === 1) {
          setSelectedWhatsapps(mappedWhatsapps[0].id);
        }
      });
  }, [currentContact, channelFilter, ticket, whatsappId]);

  useEffect(() => {
    if (contactId && contacts.length) {
      const contact = contacts.find((c) => c.id === contactId);
      if (contact) {
        setCurrentContact(contact);
      }
    }
  }, [contactId, contacts]);

  // [ANTIGRAVITY Plan 1196] Búsqueda asíncrona de contactos con debounce bajo demanda (Cero carga masiva)
  useEffect(() => {
    if (!open) return;
    if (!contactSearchParam || contactSearchParam.trim().length === 0) return;

    const delayDebounceFn = setTimeout(async () => {
      setLoadingContacts(true);
      try {
        const { data } = await api.get("/contacts", {
          params: { searchParam: contactSearchParam.trim(), pageNumber: 1 },
        });
        const results = (data.contacts || []).map((c) => ({
          id: c.id,
          name: c.name,
          number: c.number,
          channel: c.channel,
        }));
        setContacts((prev) => {
          const base = currentContact && currentContact.id ? [currentContact] : [];
          const merged = [...base, ...results];
          const unique = merged.filter((item, index, self) =>
            index === self.findIndex((t) => t.id === item.id)
          );
          return [{ id: "", name: "", number: "", channel: "" }, ...unique];
        });
      } catch (err) {
        console.error("Error searching contacts:", err);
      } finally {
        setLoadingContacts(false);
      }
    }, 300);

    return () => clearTimeout(delayDebounceFn);
  }, [contactSearchParam, open, currentContact]);

  // [ANTIGRAVITY Plan 1196] Inicialización optimizada de ScheduleModal
  useEffect(() => {
    const { companyId } = user;
    if (open) {
      try {
        (async () => {
          setLoadingContacts(true);
          let initialContactItem = null;

          // Si viene contactId específico, cargarlo directamente por ID
          if (contactId) {
            try {
              const { data: specificContact } = await api.get(`/contacts/${contactId}`);
              if (specificContact) {
                initialContactItem = {
                  id: specificContact.id,
                  name: specificContact.name,
                  number: specificContact.number,
                  channel: specificContact.channel,
                };
                setCurrentContact(initialContactItem);
                setChannelFilter(specificContact.channel || "whatsapp");
              }
            } catch (cErr) {
              console.error("Error cargando contacto inicial:", cErr);
            }
          }

          // Cargar muestra ligera inicial (20 contactos recientes) en lugar de 35,000 registros
          try {
            const { data: contactData } = await api.get("/contacts", {
              params: { pageNumber: 1 },
            });
            const rawList = contactData.contacts || contactData || [];
            let customList = rawList.map((c) => ({
              id: c.id,
              name: c.name,
              number: c.number,
              channel: c.channel,
            }));

            if (initialContactItem && !customList.some(c => c.id === initialContactItem.id)) {
              customList = [initialContactItem, ...customList];
            }

            if (isArray(customList)) {
              setContacts([{ id: "", name: "", number: "", channel: "" }, ...customList]);
            }
          } catch (listErr) {
            console.error("Error cargando muestra de contactos:", listErr);
          } finally {
            setLoadingContacts(false);
          }

          if (!scheduleId) {
            const newScheduleState = {
              ...initialState,
              body: message || "",
              contactId: contactId || "",
            };
            setSchedule(newScheduleState);
            return;
          }

          // Carregamento de agendamento existente
          const { data } = await api.get(`/schedules/${scheduleId}`);
          setSchedule((prevState) => {
            return {
              ...prevState,
              ...data,
              sendAt: moment(data.sendAt).format("YYYY-MM-DDTHH:mm"),
              reminderDate: data.reminderDate ? moment(data.reminderDate).format("YYYY-MM-DDTHH:mm") : "",
            };
          });

          if (data.whatsapp) {
            setSelectedWhatsapps(data.whatsapp.id);
          }

          if (!isAdmin && data.ticketUser) {
            setSelectedUser(data.ticketUser);
          }

          if (data.queueId) {
            setSelectedQueue(data.queueId);
          }

          if (data.intervalo) {
            setIntervalo(data.intervalo);
          }

          if (data.tipoDias) {
            setTipoDias(data.tipoDias);
          }

          if (data.contact) {
            const cItem = {
              id: data.contact.id,
              name: data.contact.name,
              number: data.contact.number,
              channel: data.contact.channel,
            };
            setCurrentContact(cItem);
            setContacts((prev) => {
              if (!prev.some((c) => c.id === cItem.id)) {
                return [cItem, ...prev];
              }
              return prev;
            });
          }
        })();
      } catch (err) {
        toastError(err);
      }
    }
  }, [scheduleId, contactId, open, user, message, fromMessageInput]);

  const filterOptions = (options, params) => {
    const filtered = createFilterOptions({
      trim: true,
      stringify: (option) => `${option.name} ${option.number}`,
    })(options, params);

    const { inputValue } = params;
    // Suggest the creation of a new value
    const isExisting = options.some((option) => inputValue === option.name || inputValue === option.number);

    if (inputValue !== '' && !isExisting) {
      const isNumber = /^\d+$/.test(inputValue);
      filtered.push({
        inputValue,
        name: isNumber ? `${inputValue}` : `${inputValue}`,
        number: isNumber ? inputValue : "",
        isAddOption: true,
        label: isNumber ? `${i18n.t("common.add")} ${i18n.t("contactModal.form.number")}: ${inputValue}` : `${i18n.t("common.add")} ${i18n.t("contactModal.form.name")}: ${inputValue}`
      });
    }

    return filtered;
  };

  const handleClose = () => {
    onClose();
    setAttachment(null);
    setSchedule(initialState);
    // ✅ MELHORIA: Reset do contato atual ao fechar
    setCurrentContact(initialContact);
    // Reset do dropdown de quickMessages
    setSelectedQuickMessage("");
    setQuickMessageSearch("");
    setShowAllQuickMessages(false);
    setFilteredQuickMessages([]);
    setQuickMessageMedia(null);
    // ✅ Reset dos campos de lembrete
    setSchedule(prevState => ({
      ...prevState,
      reminderDate: "",
    }));
  };

  const handleAttachmentFile = (e) => {
    const file = head(e.target.files);
    if (file) {
      setAttachment(file);
    }
  };

  const IconChannel = (channel) => {
    switch (channel) {
      case "facebook":
        return (
          <Facebook style={{ color: "#3b5998", verticalAlign: "middle" }} />
        );
      case "instagram":
        return (
          <Instagram style={{ color: "#e1306c", verticalAlign: "middle" }} />
        );
      case "whatsapp":
        return (
          <WhatsApp style={{ color: "#25d366", verticalAlign: "middle" }} />
        );
      default:
        return "error";
    }
  };

  const renderOption = (option) => {
    if (option.isAddOption) {
      return (
        <Typography
          component="span"
          style={{
            fontSize: 14,
            marginLeft: "10px",
            display: "inline-flex",
            alignItems: "center",
            lineHeight: "2",
            fontWeight: 500,
            color: "green"
          }}
        >
          <span style={{ marginRight: 5 }}>+</span> {option.label}
        </Typography>
      );
    }
    if (option.name) {
      return (
        <>
          {IconChannel(option.channel)}
          <Typography
            component="span"
            style={{
              fontSize: 14,
              marginLeft: "10px",
              display: "inline-flex",
              alignItems: "center",
              lineHeight: "2",
            }}
          >
            {option.name} - {option.number}
          </Typography>
        </>
      );
    } else {
      return `${i18n.t("newTicketModal.add")} ${option.name}`;
    }
  };

  const handleSaveSchedule = async (values) => {
    const scheduleData = {
      ...values,
      sendAt: moment(values.sendAt).toISOString(),
      userId: user.id,
      whatsappId: selectedWhatsapps,
      ticketUserId: selectedUser?.id || null,
      queueId: selectedQueue || null,
      intervalo: intervalo || 1,
      tipoDias: tipoDias || 4,
      // ✅ Incluir dados do lembrete (asegurando el formato ISO para timezone)
      reminderDate: values.reminderDate ? moment(values.reminderDate).toISOString() : null,
    };

    try {
      if (scheduleId) {
        await api.put(`/schedules/${scheduleId}`, scheduleData);
        if (attachment != null) {
          const formData = new FormData();
          formData.append("file", attachment);
          await api.post(`/schedules/${scheduleId}/media-upload?typeArch=reminder`, formData);
        }
      } else {
        const { data } = await api.post("/schedules", scheduleData);
        if (attachment != null) {
          const formData = new FormData();
          formData.append("file", attachment);
          await api.post(`/schedules/${data.id}/media-upload?typeArch=reminder`, formData);
        }
      }

      toast.success(i18n.t("scheduleModal.success"));

      if (typeof reload == "function") {
        reload();
      }

      if (contactId) {
        if (typeof cleanContact === "function") {
          cleanContact();
          history.push("/schedules");
        }
      }
    } catch (err) {
      toastError(err);
    }

    setCurrentContact(initialContact);
    setSchedule(initialState);
    // ✅ Reset dos campos de lembrete após salvar
    setSchedule(prevState => ({
      ...prevState,
      reminderDate: "",
    }));
    handleClose();
  };

  const handleClickMsgVar = async (msgVar, setValueFunc) => {
    const el = messageInputRef.current;
    const firstHalfText = el.value.substring(0, el.selectionStart);
    const secondHalfText = el.value.substring(el.selectionEnd);
    const newCursorPos = el.selectionStart + msgVar.length;

    setValueFunc("body", `${firstHalfText}${msgVar}${secondHalfText}`);

    await new Promise((r) => setTimeout(r, 100));
    messageInputRef.current.setSelectionRange(newCursorPos, newCursorPos);
  };

  // ✅ Función unificada para eliminar archivos adjuntos (locales o remotos)
  const handleDeleteMedia = async () => {
    try {
      if (scheduleId && schedule.mediaPath) {
        await api.delete(`/schedules/${scheduleId}/media-upload`);
      }
      setAttachment(null);
      setQuickMessageMedia(null);
      setSchedule(prev => ({
        ...prev,
        mediaPath: null,
        mediaName: null
      }));
      if (attachmentFile.current) {
        attachmentFile.current.value = null;
      }
      toast.success(i18n.t("scheduleModal.toasts.deleted"));
    } catch (err) {
      toastError(err);
    }
  };

  // Función para lidar com seleção de resposta rápida
  const handleQuickMessageSelect = async (selectedMessage, setFieldValue) => {
    console.log("🎯 Mensagem selecionada:", selectedMessage);

    if (selectedMessage) {
      console.log("✅ Preenchendo campo body com:", selectedMessage.message);
      setFieldValue("body", selectedMessage.message || "");
      setQuickMessageSearch(selectedMessage.message || "");

      // Se a mensagem tem mídia, baixar e definir como attachment
      if (selectedMessage.mediaPath) {
        console.log("📎 Mensagem com mídia:", selectedMessage.mediaPath);

        try {
          const mediaFile = await downloadQuickMessageMedia(
            selectedMessage.mediaPath,
            selectedMessage.mediaName,
            selectedMessage.mediaType
          );

          if (mediaFile) {
            setAttachment(mediaFile);
            setQuickMessageMedia({
              path: selectedMessage.mediaPath,
              name: selectedMessage.mediaName,
              type: selectedMessage.mediaType
            });
            console.log("✅ Mídia da quickMessage definida como attachment:", mediaFile);
          }
        } catch (err) {
          console.error("❌ Erro ao processar mídia da quickMessage:", err);
        }
      } else {
        // Limpar mídia anterior se não há mídia na nova seleção
        setQuickMessageMedia(null);
        setAttachment(null);
        if (attachmentFile.current) {
          attachmentFile.current.value = null;
        }
      }
    }
  };


  return (
    <div className={classes.root}>
      <ConfirmationModal
        title={i18n.t("scheduleModal.confirmationModal.deleteTitle")}
        open={confirmationOpen}
        onClose={() => setConfirmationOpen(false)}
        onConfirm={() => {
          handleDeleteMedia();
          setConfirmationOpen(false);
        }}
      >
        {i18n.t("scheduleModal.confirmationModal.deleteMessage")}
      </ConfirmationModal>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        scroll="paper"
        PaperProps={{ className: classes.dialogPaper }}
      >
        <DialogTitle disableTypography className={classes.dialogTitle}>
          <div className={classes.dialogTitleText}>
            <EventIcon style={{ color: "#00b4d8" }} />
            <span>
              {scheduleId
                ? `${i18n.t("schedules.titleModal.edit")} - ${i18n.t(`schedules.titleModal.status.${schedule.status?.toLowerCase() || 'pendiente'}`)}`
                : i18n.t("schedules.titleModal.add")}
            </span>
          </div>
          <Box display="flex" alignItems="center">
            <IconButton
              size="small"
              onClick={() => setShowHelp((prev) => !prev)}
              title="Ayuda / Información"
              style={{ marginRight: 8, color: showHelp ? "#00b4d8" : "inherit" }}
            >
              <HelpOutlineIcon fontSize="small" />
            </IconButton>
            <Typography
              variant="caption"
              style={{ opacity: 0.6, marginRight: 12, fontWeight: 500 }}
            >
              BotMix | Recordatorios
            </Typography>
            <IconButton size="small" onClick={handleClose} aria-label="Cerrar">
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
        </DialogTitle>

        <Collapse in={showHelp}>
          <Box className={classes.helpBox}>
            <Typography
              variant="body2"
              style={{
                color: "#00b4d8",
                lineHeight: 1.5,
              }}
            >
              {i18n.t("schedules.helpSummary") || "Programa recordatorios y avisos diferidos por WhatsApp. Selecciona el contacto, fecha, hora y texto del mensaje."}
            </Typography>
          </Box>
        </Collapse>
        <div style={{ display: "none" }}>
          <input
            type="file"
            accept=".png,.jpg,.jpeg"
            ref={attachmentFile}
            onChange={(e) => handleAttachmentFile(e)}
          />
        </div>
        <Formik
          initialValues={schedule}
          enableReinitialize={true}
          validationSchema={getScheduleSchema()}
          onSubmit={(values, actions) => {
            setTimeout(() => {
              handleSaveSchedule(values);
              actions.setSubmitting(false);
            }, 400);
          }}
        >
          {({ touched, errors, isSubmitting, values, setFieldValue }) => (
            <Form>
              <DialogContent className={classes.dialogContent} dividers>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} md={6} xl={6}>
                    <div className={classes.multFieldLine} style={{ margin: 0 }}>
                      <FormControl variant="outlined" fullWidth size="small">
                        <Autocomplete
                          fullWidth
                          size="small"
                          value={currentContact}
                          options={contacts}
                          loading={loadingContacts}
                          filterOptions={filterOptions}
                          onInputChange={(event, newInputValue, reason) => {
                            if (reason === "input") {
                              setContactSearchParam(newInputValue);
                            }
                          }}
                          onChange={(e, contact) => {
                            if (contact && contact.isAddOption) {
                              const isNumber = /^\d+$/.test(contact.inputValue);
                              setContactInitialValues({
                                name: isNumber ? contact.inputValue : contact.inputValue,
                                number: isNumber ? contact.inputValue : ""
                              });
                              setContactModalOpen(true);
                              return;
                            }
                            const contactId = contact ? contact.id : "";
                            setSchedule({ ...schedule, contactId });
                            setCurrentContact(contact ? contact : initialContact);
                            setChannelFilter(
                              contact ? contact.channel : "whatsapp"
                            );
                          }}
                          getOptionLabel={(option) => {
                            if (option.number) {
                              return `${option.name} - ${option.number}`;
                            }
                            return option.name || "";
                          }}
                          renderOption={renderOption}
                          getOptionSelected={(option, value) => {
                            return value.id === option.id;
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              size="small"
                              variant="outlined"
                              placeholder={i18n.t("scheduleModal.form.contact")}
                              error={touched.contactId && Boolean(errors.contactId)}
                              helperText={touched.contactId && errors.contactId}
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <>
                                    {loadingContacts ? (
                                      <CircularProgress color="inherit" size={18} />
                                    ) : null}
                                    {params.InputProps.endAdornment}
                                  </>
                                ),
                              }}
                            />
                          )}
                        />
                      </FormControl>
                    </div>
                  </Grid>
                  <Grid item xs={12} md={6} xl={6}>
                    <div
                      style={{ position: 'relative', cursor: 'pointer' }}
                      onClick={() => {
                        if (sendAtRef.current?.showPicker) sendAtRef.current.showPicker();
                        else sendAtRef.current?.click();
                      }}
                    >
                      <TextField
                        label={i18n.t("scheduleModal.form.sendAt")}
                        value={values.sendAt ? moment(values.sendAt).format("DD/MM/YYYY HH:mm") : ""}
                        variant="outlined"
                        fullWidth
                        size="small"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{ readOnly: true, style: { cursor: 'pointer' } }}
                        placeholder="dd/mm/aaaa hh:mm"
                      />
                      <input
                        ref={sendAtRef}
                        type="datetime-local"
                        value={values.sendAt || ""}
                        onChange={(e) => setFieldValue("sendAt", e.target.value)}
                        style={{ position: 'absolute', opacity: 0, width: 0, height: 0, pointerEvents: 'none' }}
                      />
                    </div>
                  </Grid>
                </Grid>

                <div className={classes.multFieldLine}>
                  <Field
                    as={TextField}
                    rows={4}
                    multiline={true}
                    label={i18n.t("scheduleModal.form.body")}
                    name="body"
                    inputRef={messageInputRef}
                    error={touched.body && Boolean(errors.body)}
                    helperText={touched.body && errors.body}
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                </div>

                {/* Campo de Busca de Respostas Rápidas */}
                <div className={classes.multFieldLine}>
                  <Autocomplete
                    fullWidth
                    options={quickMessages}
                    getOptionLabel={(option) => option.shortcode || ""}
                    onChange={(e, value) => {
                      if (value) {
                        handleQuickMessageSelect(value, setFieldValue);
                      }
                    }}
                    filterOptions={(options, params) => {
                      const filtered = options.filter((option) => 
                        (option.message || "").toLowerCase().includes(params.inputValue.toLowerCase()) ||
                        (option.shortcode || "").toLowerCase().includes(params.inputValue.toLowerCase())
                      );
                      return filtered;
                    }}
                    renderOption={(option) => (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%' }}>
                        <FlashOn style={{ fontSize: '16px', color: '#1976d2' }} />
                        <div style={{ flex: 1, overflow: 'hidden' }}>
                          <div style={{ fontWeight: 'bold', fontSize: '14px' }}>
                            {option.shortcode}
                          </div>
                          <div style={{
                            fontSize: '12px',
                            color: 'textSecondary',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                          }}>
                            {option.message}
                          </div>
                        </div>
                        {option.mediaPath && (
                          <AttachFile style={{ fontSize: '14px', color: 'textSecondary' }} />
                        )}
                      </div>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        margin="dense"
                        label={i18n.t("ticketInfo.quickMessages")}
                        placeholder={i18n.t("scheduleModal.form.quickMessagesPlaceholder")}
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: (
                            <>
                              <FlashOn style={{ marginRight: '8px', color: '#1976d2' }} />
                              {params.InputProps.startAdornment}
                            </>
                          )
                        }}
                      />
                    )}
                  />
                </div>


                <Grid container spacing={1}>
                  <Grid item xs={12} md={6} xl={3}>
                    <FormControl
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      className={classes.formControl}
                    >
                      <InputLabel id="whatsapp-selection-label">
                        {i18n.t("campaigns.dialog.form.whatsapp")}
                      </InputLabel>
                      <Field
                        as={Select}
                        label={i18n.t("campaigns.dialog.form.whatsapp")}
                        placeholder={i18n.t("campaigns.dialog.form.whatsapp")}
                        labelId="whatsapp-selection-label"
                        id="whatsappIds"
                        name="whatsappIds"
                        required
                        error={touched.whatsappId && Boolean(errors.whatsappId)}
                        value={selectedWhatsapps}
                        onChange={(event) =>
                          setSelectedWhatsapps(event.target.value)
                        }
                      >
                        {whatsapps &&
                          whatsapps.map((whatsapp) => (
                            <MenuItem key={whatsapp.id} value={whatsapp.id}>
                              {whatsapp.name}
                            </MenuItem>
                          ))}
                      </Field>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={12} xl={3}>
                    <FormControl
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      className={classes.formControl}
                    >
                      <InputLabel id="openTicket-selection-label">
                        {i18n.t("campaigns.dialog.form.openTicket")}
                      </InputLabel>
                      <Field
                        as={Select}
                        label={i18n.t("campaigns.dialog.form.openTicket")}
                        placeholder={i18n.t("campaigns.dialog.form.openTicket")}
                        labelId="openTicket-selection-label"
                        id="openTicket"
                        name="openTicket"
                        error={touched.openTicket && Boolean(errors.openTicket)}
                      >
                        <MenuItem value={"enabled"}>
                          {i18n.t("campaigns.dialog.form.enabledOpenTicket")}
                        </MenuItem>
                        <MenuItem value={"disabled"}>
                          {i18n.t("campaigns.dialog.form.disabledOpenTicket")}
                        </MenuItem>
                      </Field>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid spacing={2} container alignItems="center">
                  <Grid item xs={12} md={6}>
                    <Autocomplete
                      openOnFocus
                      fullWidth
                      size="small"
                      getOptionLabel={(option) => `${option.name}`}
                      onChange={(e, newValue) => {
                        setSelectedUser(newValue);
                        if (newValue != null && Array.isArray(newValue.queues)) {
                          if (newValue.queues.length === 1) {
                            setSelectedQueue(newValue.queues[0].id);
                          }
                          setQueues(newValue.queues);
                        } else {
                          setQueues(allQueues);
                          setSelectedQueue("");
                        }
                      }}
                      options={options}
                      filterOptions={filterOptions}
                      noOptionsText={i18n.t("transferTicketModal.noOptions")}
                      loading={loading}
                      disabled={values.openTicket === "disabled" || !isAdmin}
                      renderOption={(option) => (
                        <span>
                          {" "}
                          <UserStatusIcon user={option} /> {option.name}
                        </span>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                          className={classes.autocompleteInput}
                          label={i18n.t("scheduleModal.form.assignUser")}
                          variant="outlined"
                          onChange={(e) => setSearchParam(e.target.value)}
                        />
                      )}
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <FormControl
                      variant="outlined"
                      size="small"
                      fullWidth
                      className={classes.formControl}
                    >
                      <InputLabel>
                        {i18n.t("transferTicketModal.fieldQueueLabel")}
                      </InputLabel>
                      <Select
                        value={selectedQueue}
                        onChange={(e) => setSelectedQueue(e.target.value)}
                        label={i18n.t(
                          "transferTicketModal.fieldQueuePlaceholder"
                        )}
                        disabled={values.openTicket === "disabled"}
                      >
                        {queues.map((queue) => (
                          <MenuItem key={queue.id} value={queue.id}>
                            {queue.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <FormControl
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      className={classes.formControl}
                    >
                      <InputLabel id="statusTicket-selection-label">
                        {i18n.t("campaigns.dialog.form.statusTicket")}
                      </InputLabel>
                      <Field
                        as={Select}
                        disabled={values.openTicket === "disabled"}
                        label={i18n.t("campaigns.dialog.form.statusTicket")}
                        placeholder={i18n.t(
                          "campaigns.dialog.form.statusTicket"
                        )}
                        labelId="statusTicket-selection-label"
                        id="statusTicket"
                        name="statusTicket"
                        error={
                          touched.statusTicket && Boolean(errors.statusTicket)
                        }
                      >
                        <MenuItem value={"closed"}>
                          {i18n.t("campaigns.dialog.form.closedTicketStatus")}
                        </MenuItem>
                        <MenuItem value={"open"}>
                          {i18n.t("campaigns.dialog.form.openTicketStatus")}
                        </MenuItem>
                      </Field>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={6} style={{ display: "flex", alignItems: "center" }}>
                    <FormControlLabel
                      control={
                        <Field
                          as={Switch}
                          color="primary"
                          name="assinar"
                          checked={values.assinar}
                          disabled={values.openTicket === "disabled"}
                        />
                      }
                      label={i18n.t("scheduleModal.form.assinar")}
                    />
                  </Grid>
                </Grid>
                <br />
                <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                  {i18n.t("scheduleModal.reminder.title")}
                </Typography>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} md={5}>
                    <div
                      style={{ position: 'relative', cursor: 'pointer' }}
                      onClick={() => {
                        if (reminderDateRef.current?.showPicker) reminderDateRef.current.showPicker();
                        else reminderDateRef.current?.click();
                      }}
                    >
                      <TextField
                        label={i18n.t("scheduleModal.reminder.date")}
                        value={values.reminderDate ? moment(values.reminderDate).format("DD/MM/YYYY HH:mm") : ""}
                        variant="outlined"
                        fullWidth
                        size="small"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{ readOnly: true, style: { cursor: 'pointer' } }}
                        placeholder="dd/mm/aaaa hh:mm"
                      />
                      <input
                        ref={reminderDateRef}
                        type="datetime-local"
                        value={values.reminderDate || ""}
                        onChange={(e) => setFieldValue("reminderDate", e.target.value)}
                        style={{ position: 'absolute', opacity: 0, width: 0, height: 0, pointerEvents: 'none' }}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} md={7}>
                    <div className={classes.reminderNote}>
                      {i18n.t("scheduleModal.reminder.sameMessage")}
                    </div>
                  </Grid>
                </Grid>
                <br />
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                    {i18n.t("recurrenceSection.title")}
                  </Typography>
                  <Typography variant="caption" color="textSecondary">
                    ({i18n.t("recurrenceSection.description")})
                  </Typography>
                </div>
                <br />
                <Grid container spacing={1}>
                  <Grid item xs={12} md={4} xl={4}>
                    <FormControl size="small" fullWidth variant="outlined">
                      <InputLabel id="demo-simple-select-label">
                        {i18n.t("recurrenceSection.labelInterval")}
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={intervalo}
                        onChange={(e) => setIntervalo(e.target.value || 1)}
                        label={i18n.t("recurrenceSection.labelInterval")}
                      >
                        <MenuItem value={4}>
                          {i18n.t("recurrenceSection.options.minutes")}
                        </MenuItem>
                        <MenuItem value={1}>
                          {i18n.t("recurrenceSection.options.days")}
                        </MenuItem>
                        <MenuItem value={2}>
                          {i18n.t("recurrenceSection.options.weeks")}
                        </MenuItem>
                        <MenuItem value={3}>
                          {i18n.t("recurrenceSection.options.months")}
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={4} xl={4}>
                    <Field
                      as={TextField}
                      label={i18n.t("recurrenceSection.intervalFilterValue")}
                      name="valorIntervalo"
                      size="small"
                      error={
                        touched.valorIntervalo && Boolean(errors.valorIntervalo)
                      }
                      InputLabelProps={{ shrink: true }}
                      variant="outlined"
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} md={4} xl={4}>
                    <Field
                      as={TextField}
                      label={i18n.t("recurrenceSection.sendAsManyTimes")}
                      name="enviarQuantasVezes"
                      size="small"
                      error={
                        touched.enviarQuantasVezes &&
                        Boolean(errors.enviarQuantasVezes)
                      }
                      variant="outlined"
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} md={12} xl={12}>
                    <FormControl size="small" fullWidth variant="outlined" style={{ marginTop: "8px" }}>
                      <InputLabel id="demo-simple-select-label">
                        {i18n.t("recurrenceSection.shippingRules")}
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={tipoDias}
                        onChange={(e) => setTipoDias(e.target.value || 4)}
                        label={i18n.t("recurrenceSection.shippingRules")}
                      >
                        <MenuItem value={4}>
                          {i18n.t(
                            "recurrenceSection.shipNormallyOnNonbusinessDays"
                          )}
                        </MenuItem>
                        <MenuItem value={5}>
                          {i18n.t("recurrenceSection.sendOneBusinessDayBefore")}
                        </MenuItem>
                        <MenuItem value={6}>
                          {" "}
                          {i18n.t("recurrenceSection.sendOneBusinessDayLater")}
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
                {(schedule.mediaPath || attachment || quickMessageMedia) && (
                  <Grid xs={12} item>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <Button startIcon={<AttachFile />}>
                        {attachment ? attachment.name :
                          quickMessageMedia ? quickMessageMedia.name :
                            schedule.mediaName}
                      </Button>
                      {quickMessageMedia && (
                        <Chip
                          label="Da Resposta Rápida"
                          size="small"
                          color="primary"
                          variant="outlined"
                        />
                      )}
                      <IconButton
                        onClick={() => setConfirmationOpen(true)}
                        color="secondary"
                      >
                        <DeleteOutline color="secondary" />
                      </IconButton>
                    </div>
                  </Grid>
                )}
              </DialogContent>
              <DialogActions className={classes.dialogActions}>
                {!attachment && !schedule.mediaPath && !quickMessageMedia && (
                  <Button
                    onClick={() => attachmentFile.current.click()}
                    disabled={isSubmitting}
                    className={classes.secondaryButton}
                    startIcon={<AttachFile />}
                    style={{ borderRadius: 8, textTransform: "capitalize" }}
                  >
                    {i18n.t("quickMessages.buttons.attach")}
                  </Button>
                )}
                <Button
                  onClick={handleClose}
                  disabled={isSubmitting}
                  className={classes.dangerButton}
                  startIcon={<CloseIcon style={{ fontSize: 18 }} />}
                  style={{ textTransform: "capitalize" }}
                >
                  {i18n.t("scheduleModal.buttons.cancel")}
                </Button>
                {(schedule.sentAt === null || schedule.sentAt === "") && (
                  <Button
                    type="submit"
                    disabled={isSubmitting}
                    className={classes.applyButton}
                    startIcon={<SaveIcon />}
                    style={{ borderRadius: 8, textTransform: "capitalize" }}
                  >
                    {scheduleId
                      ? `${i18n.t("scheduleModal.buttons.okEdit")}`
                      : `${i18n.t("scheduleModal.buttons.okAdd")}`}
                    {isSubmitting && (
                      <CircularProgress
                        size={24}
                        className={classes.buttonProgress}
                      />
                    )}
                  </Button>
                )}
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog>
      <ContactModal
        open={contactModalOpen}
        initialValues={contactInitialValues}
        onClose={() => setContactModalOpen(false)}
        onSave={(newContact) => {
          if (newContact && newContact.id) {
            setContacts((prev) => [newContact, ...prev]);
            setSchedule({ ...schedule, contactId: newContact.id });
            setCurrentContact(newContact);
            setContactModalOpen(false);
          }
        }}
      />
      <ConfirmationModal
        title={i18n.t("scheduleModal.confirmationModal.deleteTitle")}
        open={confirmationOpen}
        onClose={setConfirmationOpen}
        onConfirm={handleDeleteMedia}
      >
        {i18n.t("scheduleModal.confirmationModal.deleteMessage")}
      </ConfirmationModal>
    </div >
  );
};

export default ScheduleModal;
